var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-content"},[_c('ul',_vm._l((_vm.items),function(item){return _c(_vm.listContentComponent,{key:item.id,tag:"component",attrs:{"item":item},on:{"onItemSelect":_vm.handleItemClick}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }